
import React from 'react';

const modalStyles = `
.permission-denied-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2000;
}
.permission-denied-content {
    background: white;
    padding: 30px 40px;
    border-radius: 8px;
    box-shadow: 0 5px 20px rgba(0,0,0,0.25);
    width: 90%;
    max-width: 450px;
    text-align: center;
}
.permission-denied-title {
    font-size: 1.5rem;
    font-weight: bold;
    margin-bottom: 15px;
}
.permission-denied-message {
    font-size: 1.1rem;
    color: #374151; /* gray-700 */
    margin-bottom: 25px;
}
.permission-denied-button {
    background-color: #4F46E5; /* indigo-600 */
    color: white;
    padding: 10px 25px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 1rem;
    font-weight: 500;
}
`;

const styleId = 'permission-denied-modal-styles';
if (!document.getElementById(styleId)) {
  const styleElement = document.createElement('style');
  styleElement.id = styleId;
  styleElement.innerHTML = modalStyles;
  document.head.appendChild(styleElement);
}

const PermissionDeniedModal = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    return (
        <div className="permission-denied-overlay" onClick={onClose}>
            <div className="permission-denied-content" onClick={(e) => e.stopPropagation()}>
                <h3 className="permission-denied-title">権限がありません</h3>
                <p className="permission-denied-message">
                    この操作を実行するための権限がありません。
                    <br />
                    詳細については管理者にお問い合わせください。
                </p>
                <button onClick={onClose} className="permission-denied-button">
                    閉じる
                </button>
            </div>
        </div>
    );
};

export default PermissionDeniedModal;
